import { BehaviorSubject, Subscription, tap } from 'rxjs'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { IAppStateConfig } from 'src/model/candidato-api'

export type FlagsUserCfg = {
  editaAccesoPublico: boolean
  editaAceptarLOPD: boolean
  editaAceptarRecaptcha: boolean
  editaDocAttach: boolean
  esAppCandidato: boolean
  esAppModifContratos: boolean
}

export class BaseFeaturesComponent {
  private _usercfg_subs: Subscription | undefined
  private _usercfg_subs_flags: Subscription[] = []

  protected _flags = new BehaviorSubject<FlagsUserCfg>({
    editaAccesoPublico: false,
    editaAceptarLOPD: false,
    editaAceptarRecaptcha: false,
    editaDocAttach: false,
    esAppCandidato: false,
    esAppModifContratos: false,
  })

  constructor(private appConfigService: AppConfigService) {
    this._usercfg_subs = appConfigService.$usercfg
      .pipe(
        tap((usercfg: IAppStateConfig) => {
          this._flags.next({
            editaAccesoPublico: usercfg.options.app === 'MODIFCONTRATOS',
            editaAceptarLOPD: usercfg.options.app === 'MODIFCONTRATOS',
            editaAceptarRecaptcha: usercfg.options.app === 'MODIFCONTRATOS',
            editaDocAttach: usercfg.options.app === 'MODIFCONTRATOS',
            esAppCandidato: usercfg.options.app == 'CURR',
            esAppModifContratos: usercfg.options.app == 'MODIFCONTRATOS',
          })
        })
      )
      .subscribe()
  }

  $onDestroy() {
    this._usercfg_subs?.unsubscribe()
    this._usercfg_subs_flags.forEach((s) => {
      s.unsubscribe()
    })
  }

  protected autoUnsub(sub: Subscription) {
    this._usercfg_subs_flags.push(sub)
  }

  get usercfg() {
    return this.appConfigService.usercfg
  }

  esAdmin() {
    return this.usercfg.adm
  }
}
